<template>
  <div class="ArticleActions">
    <Btn class="ib success light" @click="$up('idsSelected', idsAll)">
      {{ $t('selectAll') }}
    </Btn>
    <template v-if="idsSelected.length">
      <Btn class="ib light" @click="isModalOpen = !isModalOpen">
        {{ $t('open') }}
      </Btn>
      <Btn class="ib warning light" @click="$up('idsSelected', [])">
        {{ $t('clearSelection') }}
      </Btn>
    </template>
    <ModalForm
      v-if="isModalOpen"
      @close="isModalOpen = false"
      @submit="queueActions">
      <ArticleJobsForm
        :jobs.sync="jobs" />
      <Btn :isLoading="isSaving" type="submit">
        {{ $t('save') }}
      </Btn>
    </ModalForm>
  </div>
</template>

<script>
import { actions, getters } from '@utils'
import ArticleJobsForm from './ArticleJobsForm'
import ModalForm from '@components/modals/ModalForm'
import formJobScheme from './formJobScheme'
import { intoSequentialPromise } from '@utils/async'

export default {
  components: {
    ArticleJobsForm,
    ModalForm,
  },
  props: {
    idsSelected: { type: Array, required: true },
    idsAll: { type: Array, required: true },
  },
  data() {
    return {
      isModalOpen: false,
      isSaving: false,
      jobs: [],
    }
  },
  computed: {
    ...getters(),
  },
  methods: {
    async queueActions() {
      await this.$wrap(
        () => this.idsSelected
          .map(articleId => () => this
            .CREATE_ARTICLE_BLUEPRINT({
              articleId,
              siteId: this.queryOne('article', articleId).siteId,
              scheme: formJobScheme(this.jobs),
            }))
          .reduce(intoSequentialPromise, []),
        'isSaving',
        this.$t('submitted'),
      )

      this.jobs = []
      this.$up('idsSelected', [])
      this.isModalOpen = false
    },
    ...actions('CREATE_ARTICLE_BLUEPRINT'),
  },
}
</script>

<style lang="scss">
.ArticleActions {
}
</style>

<i18n>
{
  "en": {
    "open": "Bulk actions",
    "clearSelection": "Clear selection",
    "save": "Submit jobs",
    "selectAll": "Select all",
    "submitted": "Jobs submitted"
  }
}
</i18n>
